import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Autocomplete,
  CardHeader,
  Grid,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from "../helpers/ExtraHelpers";
import useToast from "../hooks/useToast";
import Formservice from "./../service/Formservice";
import logo from "./logo.png";
import Menu from "./Menu";
import Message from "./Message";
import Phone from "./Phone";
import NB from "./reusable/NB";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";

const INIT_FORM_ERRORS = {
  nom_error: null,
  prenom_error: null,
  date_naissance_error: null,
  cin_error: null,
  adresse_error: null,
  district_error: null,
  telephone_error: null,
  whatsapp_error: null,
  facebook_error: null,
};

function Etatcivil() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const { Toast, showToast } = useToast();
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  let ref = localStorage.getItem("ref");
  if (!ref) {
    ref = getUrlParameter("ref");

    if (ref) {
      localStorage.setItem("ref", ref);
    }
  } else {
    const newRef = getUrlParameter("ref");
    if (newRef) {
      localStorage.setItem("ref", newRef);
      ref = newRef;
    }
  }
  const parts = ref.split("_");
  const prefix = parts[0];
  const [formError, setFormError] = useState(INIT_FORM_ERRORS);
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [identif, setIdentif] = useState([]);
  const [form, setForm] = useState({
    id: "",
    ref: ref,
    nom: "",
    prenom: "",
    ddn: "",
    adres: "",
    tel1: "",
    tel2: "",
    cin: "",
    district: "",
    whatsapp: "",
    facebook: "",
  });
  const [number, setNumber] = useState([
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    " ",
    "",
  ]);
  const [compt, setCompt] = useState(false);
  const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [load_districts, setLoadDistricts] = useState(false);
  const [isPhoneNumberLengthNotValid, setPhoneNumberLengthNotValid] =
    useState(false);
  function setCINvalue(value) {
    if (value) {
      const cin = value.replace(/[^\d]/g, "");
      const number = cin.length;
      if (number < 4) {
        return cin;
      }
      if (number < 7) {
        return `${cin.slice(0, 3)} ${cin.slice(3, 6)}`;
      }
      if (number < 10) {
        return `${cin.slice(0, 3)} ${cin.slice(3, 6)} ${cin.slice(6, 9)}`;
      }

      return `${cin.slice(0, 3)} ${cin.slice(3, 6)} ${cin.slice(
        6,
        9,
      )} ${cin.slice(9, 12)}`;
    } else {
      return "";
    }
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name == "cin") {
      const newval = setCINvalue(value);
      setForm({ ...form, [name]: newval });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleChange1 = (event) => {
    const { name, value } = event.target;
    var i = 0;
    var a = 0;
    for (let index = 0; index < value.length; index++) {
      for (let indexs = 0; indexs < number.length; indexs++) {
        if (number[indexs] == value[index]) {
          i++;
        }
      }
    }
    if (i != value.length) {
      setCompt(true);
    } else {
      setCompt(false);
      setForm({ ...form, [name]: value });
    }
  };

  function handleFocusPhoneNumber() {
    setIsPhoneNumberEmpty(false);
    setPhoneNumberLengthNotValid(false);
  }

  const handleFetchDistrict = () => {
    setLoadDistricts(true);
    Formservice.districtListe()
      .then((res) => {
        if (res && res.data) {
          setDistricts(res.data);
        }
      })
      .finally(() => {
        setLoadDistricts(false);
      });
  };

  const handleenvoie = () => {
    console.log("form erreur:", formError);

    if (!Object.values(formError).every((error) => error === null)) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: "Veuillez verifier les champs avec erreur.",
      });
    } else {
      setSubmitting(true);
      if (form.id !== "") {
        Formservice.updateidentity(form)
          .then((result) => {
            handleResult(result);
          })
          .catch((err) => {
            setMessage({
              ...message,
              open: true,
              color: "red",
              messageInfo: "Erreur lors de la mise à jour de l'identité",
            });
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        Formservice.saveidentity(form)
          .then((result) => {
            handleResult(result);
          })
          .catch((err) => {
            showToast(
              TYPE_NOTIFICATION.ERROR,
              "Erreur lors de l'insertion de l'identité",
            );
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };
  function handleResult(result) {
    if (result.status) {
      showToast(TYPE_NOTIFICATION.SUCCESS, "Succès");
      setTimeout(() => {
        navigate("/etude");
      }, 1000);
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Erreur lors de l'insertion de l'identité",
      );
    }
  }

  const handleFetchEtatCivil = () => {
    Formservice.details(ref).then((result) => {
      if (result && result.data) {
        setIdentif(result.data);
        setForm({
          id: result.data.id_identite || "",
          ref: ref,
          nom: result.data.nom_identite || "",
          prenom: result.data.prenom_identite || "",
          ddn: result.data.ddn || "",
          adres: result.data.adresse || "",
          tel1: result.data.contact || "",
          cin: result.data.cin || "",
          district: result.data.district || "",
          whatsapp: result.data.whatsapp || "",
          facebook: result.data.facebook || "",
        });
      } else {
      }
    });
    if (prefix === "CI") {
      const storedName = localStorage.getItem("userName");
      const storedFirst = localStorage.getItem("firstName");
      if (storedFirst && storedName) {
        setForm({ ...form, nom: storedName, prenom: storedFirst });
      }
    }
  };

  const handleCheckError = (form) => {
    setFormError({
      adresse_error:
        String(form.adres).trim() === ""
          ? "Le champ adresse est obligatoire"
          : null,
      nom_error:
        String(form.nom).trim() === "" ? "Le champ nom est obligatoire" : null,
      prenom_error:
        String(form.prenom).trim() === ""
          ? "Le champ prenom est obligatoire"
          : null,
      date_naissance_error:
        !dayjs(form.ddn).isValid() ||
        dayjs(form.ddn).get("year") > dayjs().get("year")
          ? "Le champ date de naissance est obligatoire"
          : dayjs(form.ddn).add(18, "year").isAfter(dayjs()) &&
              identif.libelle_type !== "Stagiaire"
            ? "Vous devez avoir au moins 18 ans"
            : dayjs(form.ddn).add(90, "year").isBefore(dayjs())
              ? "Veuillez verifier votre date de naissance"
              : null,
      cin_error:
        String(form.cin).trim() === "" &&
        dayjs(form.ddn).add(19, "year").isBefore(dayjs())
          ? "Le CIN est obligatoire pour les personnes majeures"
          : null,
      district_error:
        String(form.district).trim() === ""
          ? "Le champ district est obligatoire"
          : null,
      telephone_error:
        String(form.tel1).trim() === ""
          ? "Le champ numéro de téléphone est obligatoire"
          : null,
      whatsapp_error: /* form.whatsapp.trim() !== ""
          ? "Le champ whatsapp doit être un numéro de téléphone valide"
          : */ null,
      facebook_error: /* form.facebook.trim() !== "" &&
        !isValidURL(form.facebook, true, ["facebook.com"])
          ? "Le champ facebook doit être une url valide contenant facebook.com"
          : */ null,
    });
  };

  useEffect(() => {
    handleCheckError(form);
  }, [form]);

  useEffect(() => {
    handleFetchEtatCivil();
    handleFetchDistrict();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        gridTemplateRows: "auto 1fr auto",
        minHeight: "100vh",
        backgroundColor: "#f0f0f0",
        justifyContent: "center",
      }}
    >
      <Toast />
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={() => setMessage({ ...message, open: false })}
      />

      <Menu />

      <header
        style={{
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></header>
      <Grid
        container
        bgcolor={"#fff"}
        display={"flex"}
        justifyContent={"center"}
      >
        <Grid
          item
          xs={12}
          md={10}
          lg={7}
          minHeight={"90vh"}
          borderRadius={"20px"}
          border={"2px rgba(11, 93, 208,0.5) solid "}
          boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
          display={"flex"}
          flexDirection={"column"}
          p={2.5}
        >
          <Grid item flexGrow={1}>
            <main>
              <Grid container item xs={12} justifyContent={"center"}>
                <img
                  src={logo}
                  className="App-logo"
                  alt="logo"
                  style={{
                    maxWidth: "75px",
                    maxHeight: "75px",
                    // marginLeft: "40%",
                    // display: window.innerWidth <= 600 ? "block" : "none",
                  }}
                />
              </Grid>
              <Grid container item xs={12} justifyContent="center">
                {prefix === "CI" && (
                  <h1 style={{ marginBottom: "10px" }}>Mise à jour CV</h1>
                )}
                {prefix !== "CI" && (
                  <h1 style={{ marginBottom: "10px" }}>Soumission Dossier</h1>
                )}
                <Grid
                  container
                  style={{ marginBottom: "20px" }}
                  justify="center"
                >
                  <Grid
                    border={"1px rgba(11, 93, 208,0.25) solid "}
                    boxShadow="0px 1px 2px rgba(7,71,161,0.25)"
                    xs={12}
                  >
                    <CardHeader
                      title="Référence du dossier"
                      titleTypographyProps={{ variant: "body1" }}
                      subheaderTypographyProps={{ variant: "caption" }}
                      subheader={ref}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={3}>
                    <label>Nom * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      required
                      style={{ width: "100%", marginBottom: "15px" }}
                      value={form.nom}
                      id="outlined-basic"
                      size="small"
                      label="Votre Nom"
                      variant="outlined"
                      name="nom"
                      onChange={handleChange}
                      error={!!formError.nom_error}
                      helperText={formError.nom_error}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>Prénom(s) * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      style={{ width: "100%", marginBottom: "15px" }}
                      value={form.prenom}
                      id="outlined-basic"
                      size="small"
                      label="Votre Prénom(s)"
                      variant="outlined"
                      name="prenom"
                      onChange={handleChange}
                      error={!!formError.prenom_error}
                      helperText={formError.prenom_error}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>Date de naissance * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      fullWidth
                      style={{ width: "100%", marginBottom: "15px" }}
                      id="outlined-basic"
                      size="small"
                      variant="outlined"
                      type="date"
                      required
                      name="ddn"
                      value={form.ddn}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!formError.date_naissance_error}
                      helperText={formError.date_naissance_error}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>CIN * :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      size="small"
                      label="CIN"
                      variant="outlined"
                      onChange={handleChange}
                      inputProps={{ maxLength: 18 }}
                      value={form.cin}
                      style={{ width: "100%", marginBottom: "15px" }}
                      name="cin"
                      error={!!formError.cin_error}
                      helperText={formError.cin_error}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>Adresse* :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      required
                      style={{ width: "100%", marginBottom: "15px" }}
                      value={form.adres}
                      id="outlined-basic"
                      size="small"
                      label="Lieu où vous habitez "
                      variant="outlined"
                      name="adres"
                      onChange={handleChange}
                      error={!!formError.adresse_error}
                      helperText={formError.adresse_error}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>Votre district* :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <Autocomplete
                      loading={load_districts}
                      noOptionsText ="Aucun district trouvé"
                      loadingText={"Chargement de données ..."}
                      style={{ width: "100%", marginBottom: "15px" }}
                      size="small"
                      fullWidth
                      disablePortal
                      options={districts}
                      onChange={(evt, newValue) =>
                        setForm({
                          ...form,
                          district: newValue || "",
                        })
                      }
                      value={form.district || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // name="district"
                          placeholder="District où vous habitez"
                          // onChange={handleChange}
                          error={!form.district || form.district === ""}
                          helperText={
                            !form.district || form.district === ""
                              ? "District requis"
                              : ""
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>Numéro de téléphone* :</label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={9}
                    style={{ width: "100%", marginBottom: "15px" }}
                  >
                    <Phone
                      x1={3}
                      x2={8}
                      name="tel1"
                      value={form.tel1}
                      onChange={handleChange1}
                      onFocus={handleFocusPhoneNumber}
                      error={!!formError.telephone_error}
                      helperText={formError.telephone_error}
                    />
                    {compt && (
                      <>
                        <Alert severity="error">
                          Le numero de téléphone ne contient pas de lettres
                        </Alert>
                      </>
                    )}
                    {isPhoneNumberEmpty && (
                      <>
                        <Alert severity="error">Ce champ est obligatoire</Alert>
                      </>
                    )}
                    {isPhoneNumberLengthNotValid && (
                      <>
                        <Alert severity="error">
                          Veuillez vérifier votre numéro de téléphone. La
                          longueur n'est pas valide
                        </Alert>
                      </>
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>Whatsapp :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      size="small"
                      style={{ width: "100%", marginBottom: "15px" }}
                      fullWidth
                      name="whatsapp"
                      value={formatPhoneNumber(form.whatsapp)}
                      label="Whatsapp"
                      placeholder="032 12 345 67"
                      onChange={handleChange}
                      error={!!formError.whatsapp_error}
                      helperText={formError.whatsapp_error}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <label>Facebook :</label>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <TextField
                      fullWidth
                      size="small"
                      type="url"
                      name="facebook"
                      label="Facebook"
                      value={form.facebook}
                      onChange={handleChange}
                      // error={!isValidURL(form.facebook, true, ["facebook.com"])}
                      // helperText={
                      //   !isValidURL(form.facebook, true, ["facebook.com"])
                      //     ? "Valeur incorect"
                      //     : ""
                      // }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} mb={2} mt={2} style={{ color: "red" }}>
                <NB
                  texts={[
                    "Tous les champs avec * sont obligatoires. Veuillez les compléter avant de cliquer sur enregistrer",
                  ]}
                />
              </Grid>
              <Grid display={"flex"} justifyContent={"end"} pb={4}>
                {/* <Button
              variant="outlined"
              // disabled={currentIndex < 1}
              // onClick={handlePrevious}
              sx={{ display: "none" }}
            >
              Precedent
            </Button> */}
                <LoadingButton
                  loading={submitting}
                  variant="outlined"
                  sx={{ marginLeft: "auto" }}
                  onClick={() => handleenvoie()}
                  // disabled={currentIndex > questions.length - 1}
                  // disabled={submitting || Object.values(formError).some((error) => error !== null)}
                  color="primary"
                >
                  Suivant
                </LoadingButton>
              </Grid>
            </main>
          </Grid>
          <footer
            style={{
              color: "#0747a1",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE
            DEVELOPPEMENT
          </footer>
        </Grid>
      </Grid>
    </div>
  );
}

export default Etatcivil;
